import { render, staticRenderFns } from "./DeuMatchPainelDataTable.vue?vue&type=template&id=2df49063&scoped=true&"
import script from "./DeuMatchPainelDataTable.vue?vue&type=script&lang=js&"
export * from "./DeuMatchPainelDataTable.vue?vue&type=script&lang=js&"
import style0 from "./DeuMatchPainelDataTable.vue?vue&type=style&index=0&id=2df49063&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df49063",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VBtn,VCard,VCardText,VCol,VIcon,VPagination,VProgressLinear,VRow})
